import { render, staticRenderFns } from "./GerenciarAtrasosJustificadosPage.vue?vue&type=template&id=3373e60e"
import script from "./GerenciarAtrasosJustificadosPage.vue?vue&type=script&lang=js"
export * from "./GerenciarAtrasosJustificadosPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports